import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import MultiFactorAuthenticationViewObject = Vertica.LouisPoulsen.Application.Account.Api.Responses.MultiFactorAuthenticationViewObject;
import { MfaType } from '@/enums';
import SelfServiceModal from '@/ui/shared/modals/SelfServiceModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MfaEnable',
  props: {
    mfaState: null,
    showMessage: { type: Boolean },
    requestSuccess: { type: Boolean }
  },
  emits: ["updateMfa"],
  setup(__props: any, { emit }: { emit: ({(e: 'updateMfa', type: MfaType): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    mfaState: MultiFactorAuthenticationViewObject,
    showMessage: boolean,
    requestSuccess: boolean
}




const enabled = ref(props.mfaState.current.toString() !== MfaType.None.toString());
const isApp = computed<boolean>(() => selectedType.value === MfaType.Otp.toString());
const selectedType = ref<string>(props.mfaState.current.toString());

const modalOpen = ref<boolean>(false);
function openModal() {
    modalOpen.value = true;
}

function closeModal() {
    modalOpen.value = false;
}

watch(() => enabled.value, onUpdate);
watch(() => selectedType.value, onUpdate);
function onUpdate() {
    emit('updateMfa', enabled.value ? MfaType[selectedType.value] : MfaType.None);
}


return { __sfc: true,props, emit, enabled, isApp, selectedType, modalOpen, openModal, closeModal, onUpdate, SelfServiceModal }
}

})